"use strict";
/**
 * Integrations Types - External service connections for CRM and Analytics
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationProvider = exports.IntegrationStatus = void 0;
/**
 * Integration status
 */
var IntegrationStatus;
(function (IntegrationStatus) {
    IntegrationStatus["CONNECTED"] = "connected";
    IntegrationStatus["DISCONNECTED"] = "disconnected";
    IntegrationStatus["ERROR"] = "error";
    IntegrationStatus["PENDING"] = "pending";
})(IntegrationStatus || (exports.IntegrationStatus = IntegrationStatus = {}));
/**
 * Available integration providers
 */
var IntegrationProvider;
(function (IntegrationProvider) {
    IntegrationProvider["FACEBOOK"] = "facebook";
    IntegrationProvider["GOOGLE"] = "google";
    IntegrationProvider["WHATSAPP"] = "whatsapp";
    IntegrationProvider["CALENDAR"] = "calendar";
})(IntegrationProvider || (exports.IntegrationProvider = IntegrationProvider = {}));
